import { ParametrosComponent } from "./parametros/parametros.component"; 
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { adminGuard } from "src/app/guards/admin.guard";


const routes: Routes = [
      {
        path: '',
        children: [
          {
            path: 'parametros',
            component: ParametrosComponent,
            data: {
              title: "Parámetros",
              breadcrumb: "Parametros"
            },
            canActivate: [adminGuard]
          }
        ]
      }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ParametrosRoutingModule {}